import React from 'react';
import { Helmet } from 'react-helmet-async';
import { HeroSection } from '../components/HeroSection';
import { FeatureBadges } from '../components/FeatureBadges';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { OurStory } from '../components/OurStory';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_89039fd3-cb90-48f9-88ab-9d6547dca827/artifacts/ang7mnbh_d04b0c90-39ed-4f51-93a8-9960dfd45601.jpg';

export const Home = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://wildones.com/#organization",
        "name": "Wild Ones LLC",
        "url": "https://wildones.com",
        "logo": LOGO_URL,
        "sameAs": [
          "https://www.tiktok.com/@dandhayy",
          "https://www.youtube.com/@dhaymanzo"
        ],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-803-272-5881",
          "contactType": "customer service"
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://wildones.com/#website",
        "url": "https://wildones.com",
        "name": "Wild Ones LLC",
        "description": "Premium southern-style apparel for hunters, fishers, and those who live wild and free.",
        "publisher": {
          "@id": "https://wildones.com/#organization"
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>Wild Ones LLC | Southern Style Clothing & Hats</title>
        <meta
          name="description"
          content="Premium southern-style apparel for hunters, fishers, and those who live wild and free. Shop our collection of quality long sleeve tees featuring unique outdoor designs."
        />
        <meta
          name="keywords"
          content="southern clothing, hunting apparel, outdoor wear, wild ones, country style, western wear"
        />
        <link rel="canonical" href="https://wildones.com" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://wildones.com" />
        <meta property="og:title" content="Wild Ones LLC | Southern Style Clothing & Hats" />
        <meta
          property="og:description"
          content="Premium southern-style apparel for hunters, fishers, and those who live wild and free."
        />
        <meta property="og:image" content={LOGO_URL} />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Wild Ones LLC | Southern Style Clothing & Hats" />
        <meta
          name="twitter:description"
          content="Premium southern-style apparel for hunters, fishers, and those who live wild and free."
        />
        <meta name="twitter:image" content={LOGO_URL} />
        
        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <main data-testid="home-page">
        <HeroSection />
        <FeatureBadges />
        <FeaturedProducts />
        <OurStory />
      </main>
    </>
  );
};
